import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "dialog-accepted__close" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "dialog-accepted__container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-accepted__body-svg" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "dialog-accepted__svg" })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-accepted__title" }, "Ваш заказ принят", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-accepted__description" }, "№36457", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.accepted,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.accepted) = $event)),
    class: "dialog-accepted",
    width: "449"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "dialog-accepted__close-body",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.accepted = false))
      }, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", {
          class: "dialog-accepted__btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openHistory && _ctx.openHistory(...args)))
        }, "История заказов")
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}